// https://splidejs.com/
import Splide from '@splidejs/splide';

const tabListSplide = function ($element){	
	this.ui = {
		scrollTicking: false,
		allowLinkClick: true,
		allowScrollMouseMove : false,
		pos : { x: 0, y: 0 },
		$current : null
	};

	this.init = function($element) {
		this.ui.$element = $element;
		this.bindUI($element);
		this.ui.hasSlider = !this.ui.$element.hasClass('js-tabs-noSlider');
		if(this.ui.hasSlider){
			this.ui.splide = new Splide( $element[0], {
				type   : 'loop',
				pagination: false,
				focus  : 'center',
				drag   : true,
				perPage: ($element.closest(".js-tabs-lexique").length == 0) ? 3 : null,
				autoWidth: ($element.closest(".js-tabs-lexique").length == 0) ? false : true,
				mediaQuery: 'min',
				breakpoints: {
					768: {
						perPage:  null,
						autoWidth: true,
						type: 'slide',
						focus  : 1,
					},
				}
			});
			this.ui.splide.mount();
		}

		this.ui.$current = this.ui.$tabListSplide.find(".js-tabListSplide__link").filter(".active");
		if(this.ui.$current.length == 0){
			this.ui.$current = this.ui.$tabListSplide.find(".js-tabListSplide__link").eq(0).addClass("active");
		}

		this.bindEvents();

		if(window.location.hash){
			this.ui.$tabListSplide.find(".js-tabListSplide__link").filter("[href='"+window.location.hash+"']").closest(".splide__slide").not(".splide__slide--clone").find(".js-tabListSplide__link").click();
		}else{
			this.ui.$current.addClass("active");
			if(this.ui.hasSlider){
				if (window.matchMedia("(max-width: 768px)").matches) {
					// let currentIndex = this.ui.$current.closest(".splide__slide").index();
					let currentIndex = parseInt(this.ui.$current.attr('data-index'));
					if(currentIndex){
						if(this.ui.$element.closest(".js-tabs-lexique") == 0){
							this.ui.splide.go(currentIndex);
						}else{
							this.ui.splide.go(currentIndex);
						}
					}
				}
			}
		}
	};

	this.bindUI = function($element) {
		this.ui.$tabListSplide = $element;
		this.ui.$tabListSplide__scrollableZone = this.ui.$tabListSplide.find(".js-tabListSplide__scrollableZone");
		this.ui.$tabListSplide__scrollZone = this.ui.$tabListSplide.find(".js-tabListSplide__scrollZone");
		// this.ui.$tabListSplide__link = this.ui.$tabListSplide.find(".js-tabListSplide__link"); // not usable since slider add clone slides

		this.ui.$tabs = this.ui.$tabListSplide.find(".js-tabListSplide__link").closest(".js-tabs");
		this.ui.$tabs__content = this.ui.$tabs.find(".js-tabs__content");
	};

	this.bindEvents = function() {
		this.ui.$tabListSplide.on('click', '.js-tabListSplide__link', this.onClick.bind(this));
	};

	this.onClick = function(e){
		if(this.ui.allowLinkClick){
			this.ui.$current = $(e.target);
			let href = this.ui.$current.attr("href");
			// si c'est un clone, on selection l'original
			this.ui.$current = this.ui.$tabListSplide.find(".js-tabListSplide__link").filter("[href='"+href+"']").closest(".splide__slide").not(".splide__slide--clone").find(".js-tabListSplide__link");
			this.ui.$tabListSplide.find(".js-tabListSplide__link").removeClass("active");
			this.ui.$current.addClass("active");

			if(this.ui.hasSlider){
				if (window.matchMedia("(max-width: 768px)").matches) {
					let currentIndex = this.ui.$current.closest(".splide__slide").index();
					if(currentIndex){
						this.ui.splide.go(currentIndex);
					}
				}
			}
			
			if(this.ui.$tabs__content.length > 0 && href != undefined){
				e.preventDefault();
				if(!this.ui.$current.hasClass('js-noPusHistory')){
					history.pushState({}, '', href);
				}
				this.ui.$tabs__content.addClass("hide");
				// this.ui.$tabs__content.filter(this.ui.$current.attr("href")).removeClass("hide");
				// target id="target" and class="#target" (allow multiple target while keeping an #)
				this.ui.$tabs__content.filter(href+", [class*='"+href+"']").removeClass("hide");
			}
			$('body').trigger('tablist_click',[href]);
		}else{
			e.preventDefault();
		}
	};
};

module.exports = tabListSplide;